export enum BriefStatus {
    DRAFT = "draft",
    VALIDATED = "validated",
}

export default BriefStatus;
